export default "/assets/Image/moment-card-placeholder.png"